import {
  FloatingIndicatorProps as MantineFloatingIndicatorProps,
  FloatingIndicator as MantineFloatingIndicator,
} from '@mantine/core';

export type FloatingIndicatorProps = MantineFloatingIndicatorProps;

export const FloatingIndicator = MantineFloatingIndicator;

FloatingIndicator.displayName = 'FloatingIndicator';
